import React, { useState, useEffect } from 'react';
import './AuthPortal.css';
import { buildApiUrl } from '../config/api';
import HelportBrandLogo from './HelportBrandLogo';

const authTranslations = {
  en: {
    loginTab: 'LOGIN',
    signupTab: 'SIGNUP',
    emailLabel: 'Email',
    emailPlaceholder: 'Enter your email',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Enter your password',
    forgotPasswordLink: 'Forgot Password?',
    loginBtn: 'LOG IN',
    rememberMe: 'Remember me',
    fullNameLabel: 'Full Name',
    fullNamePlaceholder: 'Enter your full name',
    emailAddrLabel: 'Email Address',
    emailAddrPlaceholder: 'Enter valid email',
    createPwdLabel: 'Create Password',
    createPwdPlaceholder: 'Create a strong password',
    agreeTermsPrefix: 'I AGREE TO THE ',
    termsLink: 'TERMS & CONDITIONS.',
    alreadyHaveAcc: 'Already have an account? ',
    logInLink: 'Log In.',
    signUpBtn: 'SIGN UP',
    resetTitle: 'Reset Password',
    forgotHint1: 'Enter your registered email address and we will send you a 6-digit recovery code.',
    sendCodeBtn: 'Send Code',
    forgotHint2: 'We sent a verification code to ',
    sixDigitLabel: '6-Digit Code',
    verifyCodeBtn: 'Verify Code',
    forgotHint3: 'Code verified! Please create a new password.',
    newPwdLabel: 'New Password',
    confirmNewPwdLabel: 'Confirm New Password',
    resetPwdBtn: 'Reset Password',
    rememberedPwd: 'Remembered your password? ',
    backToLogin: 'Back to Login.',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    termsTitle: 'Terms & Conditions',
    termsP1: 'By submitting your personal information, you consent HELPORT Pte. Ltd. DBA Helport Philippines Branch Office (HPBO) to use your personal details related to your Job Application and for the sole purposes of your job application, criminal check record and employment background check.',
    termsP2: 'HPBO upholds the principles of Non-discrimination and Equal Opportunity Employement to all applicants regardless of age, gender, educational background, race, skin color, religious affiliation and ethnicity. It subscribes to a reasonable accommodations of people with special needs or benefits which the applicable Philippine laws dearly protect.',
    closeTerms: 'Close',
    sidebarEyebrow: 'Human Resources',
    sidebarTitle: 'Recruitment Portal',
    sidebarDesc: 'Secure access for applicants and Helport hiring teams.',
    sidebarFeature1: 'Track applications in real time',
    sidebarFeature2: 'Protected document submissions',
    sidebarFeature3: 'Department-based review pipeline',
    sidebarBadge: 'Equal Opportunity Employer',
  },
  zh: {
    loginTab: '登录',
    signupTab: '注册',
    emailLabel: '电子邮箱',
    emailPlaceholder: '请输入您的邮箱',
    passwordLabel: '密码',
    passwordPlaceholder: '请输入您的密码',
    forgotPasswordLink: '忘记密码？',
    loginBtn: '开始使用',
    rememberMe: '记住我',
    fullNameLabel: '全名',
    fullNamePlaceholder: '请输入您的全名',
    emailAddrLabel: '电子邮箱地址',
    emailAddrPlaceholder: '请输入有效邮箱',
    createPwdLabel: '创建密码',
    createPwdPlaceholder: '创建强密码',
    agreeTermsPrefix: '我同意',
    termsLink: '服务条款与条件。',
    alreadyHaveAcc: '已经有账户？',
    logInLink: '登录。',
    signUpBtn: '注册',
    resetTitle: '重置密码',
    forgotHint1: '输入您注册的电子邮箱地址，我们将向您发送一个6位数的恢复验证码。',
    sendCodeBtn: '发送验证码',
    forgotHint2: '我们已将验证码发送至 ',
    sixDigitLabel: '6位验证码',
    verifyCodeBtn: '验证验证码',
    forgotHint3: '验证码已验证！请创建新密码。',
    newPwdLabel: '新密码',
    confirmNewPwdLabel: '确认新密码',
    resetPwdBtn: '重置密码',
    rememberedPwd: '记起您的密码吗？',
    backToLogin: '返回登录。',
    showPassword: '显示密码',
    hidePassword: '隐藏密码',
    termsTitle: '服务条款与条件',
    termsP1: '提交您的个人信息即表示您同意 HELPORT Pte. Ltd. DBA Helport Philippines Branch Office (HPBO) 将您的个人资料用于与您的求职申请相关的目的，且仅用于求职申请、犯罪记录核查和就业背景调查。',
    termsP2: 'HPBO 坚持不歧视和平等就业机会原则，对所有申请人不论年龄、性别、教育背景、种族、肤色、宗教信仰和民族均一视同仁。公司遵守菲律宾适用法律，为有特殊需求或应享福利的人士提供合理便利。',
    closeTerms: '关闭',
    sidebarEyebrow: '人力资源',
    sidebarTitle: '招聘门户',
    sidebarDesc: '为申请人与 Helport 招聘团队提供安全访问。',
    sidebarFeature1: '实时跟踪申请进度',
    sidebarFeature2: '安全提交申请文件',
    sidebarFeature3: '按部门顺序审核流程',
    sidebarBadge: '平等机会雇主',
  },
};

const UserIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.8" />
    <path d="M5 20c0-3.314 3.134-6 7-6s7 2.686 7 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const EmailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M3 7l9 6 9-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const LockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 11V8a4 4 0 118 0v3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const EyeIcon = ({ hidden }) => (
  hidden ? (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M3.27 3.27L20.73 20.73M10.58 10.58A2 2 0 0012 15a2 2 0 001.42-.58M9.88 5.09A10.94 10.94 0 0112 5c5 0 9.27 3.11 11 7.5a11.62 11.62 0 01-2.34 3.77M6.11 6.11A11.83 11.83 0 001 12c1.73 4.39 6 7.5 11 7.5a10.94 10.94 0 004.12-.79" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ) : (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 5C7 5 2.73 8.11 1 12.5c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 8.11 17 5 12 5z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="12.5" r="3" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  )
);

const AuthPortal = ({ onBack, lang = 'en', initialTab = 'login', onLoginSuccess }) => {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [signupName, setSignupName] = useState('');
  const [signupEmail, setSignupEmail] = useState('');
  const [signupPassword, setSignupPassword] = useState('');

  const [forgotStep, setForgotStep] = useState(1);
  const [resetEmail, setResetEmail] = useState('');
  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [passwordVisibility, setPasswordVisibility] = useState({
    login: false,
    signup: false,
    newPassword: false,
    confirmNewPassword: false,
  });

  const t = authTranslations[lang] || authTranslations.en;

  const togglePasswordVisibility = (field) => {
    setPasswordVisibility((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const renderField = ({
    icon: Icon,
    type = 'text',
    placeholder,
    value,
    onChange,
    fieldKey,
    showToggle = false,
  }) => {
    const isVisible = fieldKey ? passwordVisibility[fieldKey] : false;
    const inputType = showToggle ? (isVisible ? 'text' : 'password') : type;

    return (
      <div className="auth-field">
        <span className="auth-field-icon"><Icon /></span>
        <input
          type={inputType}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required
        />
        {showToggle && fieldKey && (
          <button
            type="button"
            className="auth-password-toggle"
            onClick={() => togglePasswordVisibility(fieldKey)}
            aria-label={isVisible ? t.hidePassword : t.showPassword}
            title={isVisible ? t.hidePassword : t.showPassword}
          >
            <EyeIcon hidden={isVisible} />
          </button>
        )}
      </div>
    );
  };

  const fetchApi = async (action, options) => {
    const url = buildApiUrl(action);
    const response = await fetch(url, options);
    const text = await response.text();

    if (!response.ok) {
      throw new Error(`HTTP Error ${response.status}: ${text}`);
    }

    try {
      return JSON.parse(text);
    } catch {
      throw new Error(`PHP Output Error:\n\nNaka-connect ang system, pero hindi JSON ang ibinalik ng PHP. Narito ang ibinalik nito:\n\n${text}`);
    }
  };

  useEffect(() => {
    setActiveTab(initialTab);
  }, [initialTab]);

  useEffect(() => {
    if (activeTab !== 'forgot') {
      setForgotStep(1);
      setResetEmail('');
      setResetCode('');
      setNewPassword('');
      setConfirmNewPassword('');
      setIsSubmitting(false);
    }
  }, [activeTab]);

  useEffect(() => {
    if (!showTermsModal) return undefined;

    const handleEscape = (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      setShowTermsModal(false);
    };

    window.addEventListener('keydown', handleEscape, true);
    return () => window.removeEventListener('keydown', handleEscape, true);
  }, [showTermsModal]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const data = await fetchApi('login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: loginEmail, password: loginPassword }),
      });

      if (data.status === 'success') {
        onLoginSuccess(data.user);
      } else {
        alert(data.message || 'Login failed.');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert(error.message);
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    if (!termsAccepted) return;

    try {
      const data = await fetchApi('signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: signupName, email: signupEmail, password: signupPassword }),
      });
      if (data.status === 'success') {
        alert(data.message);
        setActiveTab('login');
        setTermsAccepted(false);
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error('Signup error:', error);
      alert(error.message);
    }
  };

  const handleSendCode = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const data = await fetchApi('forgot_password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: resetEmail }),
      });

      if (data.status === 'success') {
        alert(data.message || (data.code ? `Your reset code: ${data.code}` : 'Reset code sent.'));
        setForgotStep(2);
      } else {
        alert(data.message || 'Unable to send reset code.');
      }
    } catch (error) {
      console.error('Send code error:', error);
      alert(`Error detalye:\n\n${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const sanitizedCode = (resetCode || '').toString().replace(/\D/g, '');
      const data = await fetchApi('verify_reset_code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: resetEmail, code: sanitizedCode }),
      });

      if (data.status === 'success') {
        alert(data.message || 'Code verified.');
        setForgotStep(3);
      } else {
        alert(data.message || 'Invalid verification code.');
      }
    } catch (error) {
      console.error('Verify code error:', error);
      alert(`Error detalye:\n\n${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmNewPassword) {
      alert('Passwords do not match.');
      return;
    }
    if (newPassword.length < 8) {
      alert('Please choose a password with at least 8 characters.');
      return;
    }

    setIsSubmitting(true);
    try {
      const sanitizedCode = (resetCode || '').toString().replace(/\D/g, '');
      const data = await fetchApi('reset_password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: resetEmail, code: sanitizedCode, password: newPassword }),
      });

      if (data.status === 'success') {
        alert(data.message || 'Password has been reset. You can now log in.');
        setActiveTab('login');
        setForgotStep(1);
        setResetEmail('');
        setResetCode('');
        setNewPassword('');
        setConfirmNewPassword('');
      } else {
        alert(data.message || 'Unable to reset password.');
      }
    } catch (error) {
      console.error('Reset password error:', error);
      alert(`Error detalye:\n\n${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const openTermsModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowTermsModal(true);
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card-split has-panel-close">
        <button type="button" className="close-auth-btn" onClick={onBack} aria-label="Close">&times;</button>

        <aside className="auth-sidebar">
          <div className="auth-sidebar-decor" aria-hidden="true">
            <span className="auth-grid-fill" />
            <span className="auth-blob auth-blob--1" />
            <span className="auth-blob auth-blob--2" />
            <span className="auth-blob auth-blob--3" />
            <span className="auth-blob auth-blob--4" />
            <span className="auth-ring auth-ring--1" />
            <span className="auth-ring auth-ring--2" />
            <span className="auth-ring auth-ring--3" />
            <span className="auth-dots auth-dots--1" />
            <span className="auth-dots auth-dots--2" />
            <span className="auth-dots auth-dots--3" />
            <span className="auth-line auth-line--1" />
            <span className="auth-line auth-line--2" />
            <span className="auth-arc auth-arc--1" />
          </div>

          <div className="auth-sidebar-content">
            <span className="auth-sidebar-eyebrow">{t.sidebarEyebrow}</span>
            <h2 className="auth-sidebar-title">{t.sidebarTitle}</h2>
            <p className="auth-sidebar-desc">{t.sidebarDesc}</p>
            <ul className="auth-sidebar-features">
              <li>{t.sidebarFeature1}</li>
              <li>{t.sidebarFeature2}</li>
              <li>{t.sidebarFeature3}</li>
            </ul>
            <div className="auth-sidebar-badge">{t.sidebarBadge}</div>
          </div>

          <div className="auth-sidebar-wave" aria-hidden="true" />
        </aside>

        <div className="auth-main-panel">
          <div className="auth-logo-wrap">
            <HelportBrandLogo showTagline />
          </div>

          {activeTab !== 'forgot' && (
            <div className="auth-tabs">
              <button
                type="button"
                className={`auth-tab ${activeTab === 'login' ? 'active' : ''}`}
                onClick={() => setActiveTab('login')}
              >
                {t.loginTab}
              </button>
              <button
                type="button"
                className={`auth-tab ${activeTab === 'signup' ? 'active' : ''}`}
                onClick={() => setActiveTab('signup')}
              >
                {t.signupTab}
              </button>
            </div>
          )}

          <div className="auth-content fade-in">
            {activeTab === 'login' && (
              <form className="auth-form" onSubmit={handleLogin}>
                {renderField({
                  icon: EmailIcon,
                  type: 'email',
                  placeholder: t.emailPlaceholder,
                  value: loginEmail,
                  onChange: (e) => setLoginEmail(e.target.value),
                })}
                {renderField({
                  icon: LockIcon,
                  placeholder: t.passwordPlaceholder,
                  value: loginPassword,
                  onChange: (e) => setLoginPassword(e.target.value),
                  fieldKey: 'login',
                  showToggle: true,
                })}

                <button type="submit" className="auth-primary-btn">{t.loginBtn}</button>

                <div className="auth-form-row">
                  <label className="auth-remember">
                    <input
                      type="checkbox"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                    <span>{t.rememberMe}</span>
                  </label>
                  <button type="button" className="auth-text-link" onClick={() => setActiveTab('forgot')}>
                    {t.forgotPasswordLink}
                  </button>
                </div>
              </form>
            )}

            {activeTab === 'signup' && (
              <form className="auth-form" onSubmit={handleSignup}>
                {renderField({
                  icon: UserIcon,
                  placeholder: t.fullNamePlaceholder,
                  value: signupName,
                  onChange: (e) => setSignupName(e.target.value),
                })}
                {renderField({
                  icon: EmailIcon,
                  type: 'email',
                  placeholder: t.emailAddrPlaceholder,
                  value: signupEmail,
                  onChange: (e) => setSignupEmail(e.target.value),
                })}
                {renderField({
                  icon: LockIcon,
                  placeholder: t.createPwdPlaceholder,
                  value: signupPassword,
                  onChange: (e) => setSignupPassword(e.target.value),
                  fieldKey: 'signup',
                  showToggle: true,
                })}

                <label className="auth-terms-check">
                  <input
                    type="checkbox"
                    checked={termsAccepted}
                    onChange={(e) => setTermsAccepted(e.target.checked)}
                    required
                  />
                  <span>
                    {t.agreeTermsPrefix}
                    <button type="button" className="auth-text-link auth-text-link--inline" onClick={openTermsModal}>
                      {t.termsLink}
                    </button>
                  </span>
                </label>

                <p className="auth-switch-prompt">
                  {t.alreadyHaveAcc}
                  <button type="button" className="auth-text-link auth-text-link--inline" onClick={() => setActiveTab('login')}>
                    {t.logInLink}
                  </button>
                </p>

                <button
                  type="submit"
                  className={`auth-primary-btn ${termsAccepted ? '' : 'is-disabled'}`}
                  disabled={!termsAccepted}
                >
                  {t.signUpBtn}
                </button>
              </form>
            )}

            {activeTab === 'forgot' && (
              <div className="auth-form auth-form--forgot">
                <h3 className="auth-forgot-title">{t.resetTitle}</h3>

                {forgotStep === 1 && (
                  <form onSubmit={handleSendCode}>
                    <p className="auth-forgot-hint">{t.forgotHint1}</p>
                    {renderField({
                      icon: EmailIcon,
                      type: 'email',
                      placeholder: t.emailPlaceholder,
                      value: resetEmail,
                      onChange: (e) => setResetEmail(e.target.value),
                    })}
                    <button type="submit" className="auth-primary-btn" disabled={isSubmitting}>
                      {isSubmitting ? 'Sending...' : t.sendCodeBtn}
                    </button>
                  </form>
                )}

                {forgotStep === 2 && (
                  <form onSubmit={handleVerifyCode}>
                    <p className="auth-forgot-hint">
                      {t.forgotHint2}
                      <strong>{resetEmail}</strong>.
                    </p>
                    <div className="auth-field auth-field--code">
                      <input
                        type="text"
                        placeholder="000000"
                        maxLength="6"
                        value={resetCode}
                        onChange={(e) => setResetCode(e.target.value)}
                        required
                      />
                    </div>
                    <button type="submit" className="auth-primary-btn" disabled={isSubmitting}>
                      {isSubmitting ? 'Verifying...' : t.verifyCodeBtn}
                    </button>
                  </form>
                )}

                {forgotStep === 3 && (
                  <form onSubmit={handleResetPassword}>
                    <p className="auth-forgot-hint">{t.forgotHint3}</p>
                    {renderField({
                      icon: LockIcon,
                      placeholder: '••••••••',
                      value: newPassword,
                      onChange: (e) => setNewPassword(e.target.value),
                      fieldKey: 'newPassword',
                      showToggle: true,
                    })}
                    {renderField({
                      icon: LockIcon,
                      placeholder: '••••••••',
                      value: confirmNewPassword,
                      onChange: (e) => setConfirmNewPassword(e.target.value),
                      fieldKey: 'confirmNewPassword',
                      showToggle: true,
                    })}
                    <button type="submit" className="auth-primary-btn" disabled={isSubmitting}>
                      {isSubmitting ? 'Resetting...' : t.resetPwdBtn}
                    </button>
                  </form>
                )}

                <p className="auth-switch-prompt">
                  {t.rememberedPwd}
                  <button
                    type="button"
                    className="auth-text-link auth-text-link--inline"
                    onClick={() => { setActiveTab('login'); setForgotStep(1); }}
                  >
                    {t.backToLogin}
                  </button>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {showTermsModal && (
        <div className="terms-modal-overlay" onClick={() => setShowTermsModal(false)} role="presentation">
          <div
            className="terms-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="terms-modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="terms-modal-header">
              <h3 id="terms-modal-title">{t.termsTitle}</h3>
              <button type="button" className="terms-modal-close" onClick={() => setShowTermsModal(false)} aria-label={t.closeTerms}>
                &times;
              </button>
            </div>
            <div className="terms-modal-body">
              <p>{t.termsP1}</p>
              <p>{t.termsP2}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuthPortal;
